import React, { CSSProperties, ReactElement } from "react";
import { useWindowWidth } from "@react-hook/window-size";
import Modal from "../../Modal/Modal";
import Text from "../../Text/Text";

interface RequestAccessOrPermissionModalProps {
  show: boolean;
  type?: "access" | "permission";
  onClose: () => void;
}

const RequestAccessOrPermissionModal: React.FC<RequestAccessOrPermissionModalProps> = ({
  show,
  type = "permission",
  onClose,
}): ReactElement => {
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth <= 576;

  const getModalStyles = (): CSSProperties => {
    return isMobile
      ? {
          top: "0",
          left: "0",
          width: "100vw",
          height: "100vh",
          borderRadius: "0",
          position: "fixed",
        }
      : {
          width: "576px",
          height: "294px",
          marginTop: "150px",
          padding: "25px",
        };
  };

  return (
    <Modal
      cancelText="OK"
      cancelButtonColor="blue"
      show={show}
      onClose={onClose}
      describedBy={`Request ${type}`}
      labelledBy={`Request ${type}`}
      style={getModalStyles()}
      focusOnClose="username"
    >
      <Text
        wrapper="h1"
        type="header"
        style={{
          lineHeight: "140%",
          letterSpacing: "0.0015em",
          marginBottom: "20px",
          textTransform: "capitalize",
        }}
        color="#252525"
        size="36px"
      >
        Request {type}
      </Text>
      <Text type="body" color="#252525" size="16px" style={{ marginBottom: "0px" }}>
        {type === "permission"
          ? "You currently do not have the right permissions to access this app."
          : "You currently do not have access to this app."}
        {" "}Please contact Digital Factory at{" "}
        <a href="mailto:digitalfactory@networkrail.co.uk" style={{ textDecoration: "underline" }}>
          digitalfactory@networkrail.co.uk
        </a>{" "}
        to request access to this app.
      </Text>
    </Modal>
  );
};

export default RequestAccessOrPermissionModal;
